<template>
  <div id="CustomSelect" class="dmh-confirm-container w-100 mb-0 p-0">
    <label class="dmh-confirm-field">{{ question.field_label }}</label>
    <div class="select-display" @click="toggleDropdown">
      <span>{{ selectedLabel }}</span>
      <i class="fa fa-chevron-down arrow"></i>
    </div>

    <ul v-if="isOpen" class="select-options">
      <li
        v-for="(option, index) in question.options"
        :key="index"
        @click="selectOption(option)"
        :class="{ selected: option === value }"
      >
        <span class="checkbox"></span>
        <span>{{ option }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CustomSelect",
  props: ["question", "answer"],
  data() {
    return {
      isOpen: false,
      value: this.answer[this.question.field_key] || null
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.question.options.find(opt => opt === this.value);
      return selected ? selected : "Select...";
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.value = option;
      this.isOpen = false;
      this.answer[this.question.field_key] = option;
    },
  },
};
</script>

<style lang="less">
#CustomSelect {
  position: relative;
  font-family: sans-serif;

  .dmh-confirm-field {
    padding: 15px 15px 0;
  }
  
  .select-display {
    padding: 0 15px 15px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      color: #1e1e22;
      font-family: var(--font-regular, "DMSans");
      font-size: 1.6rem;
    }
  }
  
  .arrow {
    padding: 12px;
    background-color: rgba(30, 30, 34, 0.05);
    border-radius: 12px;
  }

  .select-options {
    width: 100%;
    display: flex;
    font-size: 1.6rem;
    flex-direction: column;
    gap: 16px;
    list-style: none;
    margin: 0;
    padding: 20px 30px;
    border: 1px solid rgba(174, 176, 189, 1);
    border-radius: 5px;
    top: 100%;
    border-radius: 5px;
    position: absolute;
    background: white;
    z-index: 1000;
  }
  
  .select-options li {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: var(--font-regular, "DMSans");
  }

  .checkbox {
    display: inline-block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    border: 2px solid rgba(132, 129, 138, 1);
    margin-right: 15px;
  }
  
  .select-options li.selected {
    color: var(--brand-primary);

    .checkbox {
      background-color: var(--brand-primary);
      border-color: var(--brand-primary);
    }
  }
}
</style>
